import types from '../types';

/**
 * @param {types.CheckBoxOrRadioOption[]} options
 * @returns {types.CheckBoxOrRadioOption[]}
 */
const getResetedCheckboxGroupState = options => {
    if (!options || !Array.isArray(options) || !options.length) {
        throw new Error('Options are missing!');
    }

    return options.map(option => {
        if (
            option.subcategoriesContent &&
            option.subcategoriesContent.subcategories &&
            option.subcategoriesContent.subcategories.length
        ) {
            const { subcategories } = option.subcategoriesContent;

            const nextSubcategories = subcategories.map(item => {
                return {
                    ...item,
                    checked: false
                };
            });

            return {
                ...option,
                checked: false,
                subcategoriesContent: {
                    ...option.subcategoriesContent,
                    subcategories: nextSubcategories
                }
            };
        }

        return {
            ...option,
            checked: false
        };
    });
};

export default getResetedCheckboxGroupState;
